import React, { useState, useEffect, useMemo } from "react";
import PowerBi from "@pages/PowerBi";
import PageHeader from "@features/shared/components/PageHeader";
import { useSelector } from "react-redux";

/**
 * BranchPerformanceIndex Component
 * Displays Power BI branch performance dashboard based on sales group
 * Optimized with React.memo and useMemo for performance
 */
const BranchPerformanceIndex = () => {
  const [pageId, setPageId] = useState({});
  const [loading, setLoading] = useState(true);
  
  // Custom equality check for selected sales group code
  const selectedSalesGroupCode = useSelector(
    (state) =>
      state?.userDetails?.details?.Sales_Group_Code__c ||
      state?.SelectedSalesGroupCode?.SalesGroupCode,
    (left, right) => left === right
  );

  // Memoized sales group configuration
  const salesGroups = useMemo(
    () => ({
      105: { id: "223cd674c97ddc2da176", name: "Branch Performance Index - FV" },
      111: {
        id: "44fc726661060e5f4f3d",
        name: "Branch Performance Index - Aradlite",
      },
      201: {
        id: "7de9d97612731f282565",
        name: "Branch Performance Index - ASF",
      },
      301: {
        id: "89b5290e50834ee74325",
        name: "Branch Performance Index - MNT",
      },
      401: { id: "d5a214c4e18e6567daad", name: "Branch Performance Index - CC" },
      406: {
        id: "e540c588abdd1363d6e1",
        name: "HeadqBranch Performance Index - Roff",
      },
      901: {
        id: "dde204f9b616fc883970",
        name: "Branch Performance Index - Rurban",
      },
      902: {
        id: "25ed67a88267d3dcf2a2",
        name: "Branch Performance Index - STI",
      },
    }),
    []
  );

  // Effect to update page ID when sales group changes
  useEffect(() => {
    if (selectedSalesGroupCode) {
      if (salesGroups[selectedSalesGroupCode]) {
        setPageId(salesGroups[selectedSalesGroupCode]);
      } else {
        setPageId({});
      }
      setLoading(false);
    }
  }, [selectedSalesGroupCode, salesGroups]);

  return (
    <>
      <PageHeader title="Branch Performance Index" path="/" />
      {!loading && (
        <div className="p-2">
          <PowerBi
            id="c4018d9d-f992-490f-847e-b6d57e69a3f5"
            pageName={pageId}
            tableName="SH2Master"
            height={"80vh"}
          />
        </div>
      )}
    </>
  );
};

export default React.memo(BranchPerformanceIndex);
